var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
let RoombaSettingsIndexRoute = (_class = class RoombaSettingsIndexRoute extends Route {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "graphql", _descriptor, this);
    _initializerDefineProperty(this, "state", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
  }
  async beforeModel() {
    try {
      await this.graphql.getCompany();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('company does not exist yet. creating!', e);
      await this.graphql.createCompany();
    }
  }
  async model() {
    const {
      currentLocation
    } = this.state;
    if (!currentLocation) {
      throw new Error('no current location found while loading roomba settings');
    }
    const [company, roomLocationConfig, spaceSaverConfig, rooms] = await Promise.all([this.graphql.getCompany(), this.graphql.getRoomsLocationWithConfigs(currentLocation.id), this.graphql.getSpaceSaverConfig(), this.graphql.getRooms(this.state.currentLocation?.id)]);
    const plugins = await this.store.query('plugin', {
      include: 'plugin',
      filter: {
        notification_channels: true
      },
      page: {
        limit: 100
      }
    });
    return {
      company,
      currentLocation,
      roomLocationConfig,
      spaceSaverConfig,
      plugins,
      rooms
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { RoombaSettingsIndexRoute as default };